import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

const prepareList = data => {
  const list = [];

  data.forEach(item => {
    const el = {
      key: item.id,
      ...item,
      operations: item
    };
    list.push(el);
  });

  return list;
};

// `query` is optional - omitting it returns the first page of the whole catalogue. Follow-up pages
// are loaded from the response's ready-made `next` URL (it carries the cursor), so no params then.
function* getShopifyCollections({ payload: { signal, searchQ, pageUrl } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.shopify.search_collections,
      ...(pageUrl ? { url: pageUrl } : { params: { ...(searchQ && { query: searchQ }) } }),
      signal
    });

    const preparedData = {
      dataTable: prepareList(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.previous,
      append: Boolean(pageUrl)
    };

    yield put(actions.getShopifyCollectionsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getShopifyCollectionsFailed,
      // Every caller shows the `query` error (e.g. under 3 characters) under its search field
      handledErrors: ['query'],
      endpoint: api.shopify.search_collections.url
    });
  }
}

export const getShopifyCollectionsSaga = takeEvery(types.GET_SHOPIFY_COLLECTIONS_REQUEST, getShopifyCollections);